import { useState } from "react";
import { Link } from "react-router-dom";
import api, { errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(null);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setDone(data);
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#090D16] px-6" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
      <div className="w-full max-w-sm">
        <h2 className="text-2xl font-bold tracking-tight text-slate-50" style={{ fontFamily: "Outfit, sans-serif" }}>Reset password</h2>
        <p className="mt-1 text-sm text-slate-500">Enter your account email to receive a reset link.</p>
        {done ? (
          <div data-testid="forgot-success" className="mt-6 space-y-3">
            <p className="rounded-lg border border-emerald-500/30 bg-emerald-500/10 px-3 py-2 text-sm text-emerald-400">{done.message}</p>
            {done.dev_reset_link && (
              <p className="rounded-lg border border-slate-700 bg-[#111827] px-3 py-2 text-xs text-slate-400">
                Demo environment — open reset link:{" "}
                <Link data-testid="forgot-dev-link" to={done.dev_reset_link} className="text-orange-400 underline">Reset password</Link>
              </p>
            )}
            <Link to="/login" className="block text-xs text-orange-400 hover:text-orange-300">Back to sign in</Link>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-4" data-testid="forgot-form">
            <Input data-testid="forgot-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com" required
              className="border-slate-700 bg-[#111827] text-slate-100 placeholder:text-slate-600 focus-visible:ring-orange-500" />
            {error && <p data-testid="forgot-error" className="text-xs text-rose-400">{error}</p>}
            <Button data-testid="forgot-submit-btn" disabled={busy} className="w-full bg-orange-500 font-semibold text-white hover:bg-orange-600">
              {busy ? "Sending…" : "Send reset link"}
            </Button>
            <Link to="/login" className="block text-center text-xs text-slate-500 hover:text-slate-300">Back to sign in</Link>
          </form>
        )}
      </div>
    </div>
  );
}
